import { render, staticRenderFns } from "./BubbleIcon.vue?vue&type=template&id=5399aefc"
import script from "./BubbleIcon.vue?vue&type=script&lang=ts"
export * from "./BubbleIcon.vue?vue&type=script&lang=ts"
import style0 from "./BubbleIcon.vue?vue&type=style&index=0&id=5399aefc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports